import { render, staticRenderFns } from "./OrdersWithGoogleAdsTasksStatuses.vue?vue&type=template&id=b1762270&scoped=true&"
import script from "./OrdersWithGoogleAdsTasksStatuses.vue?vue&type=script&lang=js&"
export * from "./OrdersWithGoogleAdsTasksStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1762270",
  null
  
)

export default component.exports